<template>
  <Navbar />
  <div class="body verify-container auth-page-skin auth-visual-layout" :dir="direction">
    <div class="verify-card auth-panel">
      <h2>{{ $t('verifyOtp.title') }}</h2>
      <p class="subtitle">
        {{ $t('verifyOtp.subtitle') }}
        <strong>{{ phoneNumber }}</strong>
        {{ $t('verifyOtp.subtitleSuffix') }}
      </p>

      <form @submit.prevent="handleVerifyOtp">
        <div class="form-group">
          <label class="form-label">{{ $t('verifyOtp.label') }}</label>
          <input 
            v-model="otp"
            type="text" 
            class="form-input" 
            :placeholder="$t('verifyOtp.placeholder')"
            maxlength="6"
            required
          />
          <div v-if="error" class="text-danger">{{ error }}</div>
        </div>

        <button type="submit" class="verify-btn" :disabled="loading">
          {{ loading ? $t('verifyOtp.loading') : $t('verifyOtp.submit') }}
        </button>
      </form>

      <p class="resend-link">
        {{ $t('verifyOtp.notReceived') }}
        <a href="#" @click.prevent="handleResendOtp">
          {{ $t('verifyOtp.resend') }}
        </a>
      </p>
    </div>
  

      <div class="register-image-col" aria-hidden="true">
        <div class="visual">
          <div class="hero-orbit">
            <img class="visual-image" src="@/assets/register-login-bg.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { registerService } from '@/services/api'
import Navbar from '@/components/navbar_styled_register.vue';

export default {
  name: 'VerifyOtpPage',
  components: {
    Navbar,
  },
  setup() {
    const router = useRouter()
    const phoneNumber = ref('')
    const otp = ref('')
    const loading = ref(false)
    const error = ref('')

    const direction = computed(() => {
      return 'rtl'
    })

    const handleVerifyOtp = async () => {
      if (!otp.value || otp.value.length !== 6) {
        error.value = 'Please enter a valid 6-digit OTP'
        return
      }

      loading.value = true
      error.value = ''

      try {
        const response = await registerService.verifyOtp(phoneNumber.value, otp.value)
        //console.log(response)
        if (response.data.success) {
          // Store customer ID if needed
          if (response.data.customer_id) {
            localStorage.setItem('customerId', response.data.customer_id)
          }
          router.push('/set-password')
        } else {
          throw new Error(response.data.message)
        }
      } catch (err) {
        console.log(err.response);
        if (err.response?.status == 400) {
          error.value = 'کد یکبار مصرف منقضی شده یا اشتباه است'
        }else if(err.response?.status == 404) {
          error.value = 'شماره تلفن شما در سیستم ثبت نشده است'
        }else if(err.response?.status == 409) {
          error.value = 'این شماره موبایل قبلاً ثبت شده است'
        }else {
          error.value = 'تایید کد یکبار مصرف موفق آمیز نبود ,لطفا مجددا امتحان کنید'
        }
      } finally {
        loading.value = false
      }
    }

    const handleResendOtp = async () => {
      try {
        await registerService.resendOtp(phoneNumber.value)
        alert('OTP has been resent successfully!')
      } catch (err) {
        error.value = 'Failed to resend OTP. Please try again.'
      }
    }

    onMounted(() => {
      const savedPhone = localStorage.getItem('pendingPhoneNumber')
      if (!savedPhone) {
        router.push('/register')
        return
      }
      phoneNumber.value = savedPhone
    })

    return {
      phoneNumber,
      otp,
      loading,
      error,
      direction,
      handleVerifyOtp,
      handleResendOtp
    }
  }
}
</script>

<style scoped>
.verify-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f9fafb;
}

.verify-card {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  text-align: center;
  width: 100%;
  max-width: 400px;
}

.verify-card h2 {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.subtitle {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.verify-btn {
  width: 100%;
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 0.75rem;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.verify-btn:hover:not(:disabled) {
  background-color: #1d4ed8;
}

.verify-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.resend-link {
  margin-top: 1rem;
  font-size: 0.9rem;
}

.resend-link a {
  color: #2563eb;
  text-decoration: none;
}

.resend-link a:hover {
  text-decoration: underline;
}

.text-danger {
  color: #dc2626;
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

.verify-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--bg);
}

/* Card */
.verify-card {
  background: var(--card-bg);
  padding: 2rem;
  border-radius: 8px;
  box-shadow: var(--shadow-2);
  text-align: center;
  width: 100%;
  max-width: 400px;
}

/* Title */
.verify-card h2 {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: var(--text);
}

/* Subtitle */
.subtitle {
  font-size: 0.95rem;
  color: var(--subtext);
  margin-bottom: 1.5rem;
}

/* Label */
.form-label {
  display: block;
  font-weight: 500;
  margin-bottom: 0.25rem;
  color: var(--text);
}

/* Input */
.form-input {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid var(--border);
  border-radius: 6px;
  margin-bottom: 1rem;
  font-size: 1rem;
  background: var(--input-bg, var(--card-bg));
  color: var(--text);
  text-align: center;


  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-input:focus {
  border-color: var(--primary);
  outline: none;
  box-shadow: 0 0 0 3px var(--ring);
}

/* Button */
.verify-btn {
  width: 100%;
  background-color: var(--primary);
  color: var(--text-light, #fff);
  border: none;
  padding: 0.75rem;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.verify-btn:hover:not(:disabled) {
  background-color: var(--primary-hover);
}

.verify-btn:disabled {
  background-color: var(--disabled);
  cursor: not-allowed;
}

/* Resend */
.resend-link {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: var(--text);
}

.resend-link a {
  color: var(--primary);
  text-decoration: none;
}

.resend-link a:hover {
  text-decoration: underline;
}

/* Error Text */
.text-danger {
  color: var(--red);
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

/* Shared Register-style auth UI */
.auth-page-skin { --auth-text:#f1f7f5; --auth-muted:#9bb5b4; --auth-surface:rgba(12,42,51,.72); --auth-border:rgba(145,205,194,.2); --auth-input:rgba(5,24,31,.72); --auth-accent:#f07832; --auth-accent-soft:#ff9b5f; position:relative; isolation:isolate; min-height:calc(100svh - 64px); overflow:hidden; padding:56px 20px 72px; color:var(--auth-text); background:radial-gradient(circle at 72% 45%,rgba(35,110,118,.25),transparent 34%),linear-gradient(135deg,#06151e 0%,#08242e 52%,#071b25 100%); font-family:'Vazirmatn',Tahoma,'Segoe UI',sans-serif; }
.auth-page-skin::before { content:''; position:absolute; z-index:-1; inset:-12%; background:url('~@/assets/register-login-bg.svg') center / min(720px,92vw) auto no-repeat; opacity:.34; pointer-events:none; }
.auth-page-skin::after { content:''; position:absolute; z-index:-1; inset:20%; border-radius:50%; background:rgba(240,120,50,.12); filter:blur(70px); pointer-events:none; }
.auth-page-skin > * { position:relative; z-index:1; }
.auth-page-skin .auth-panel { position:relative; z-index:2; width:min(100%,440px); margin:0 auto; padding:36px 32px 30px; border:1px solid var(--auth-border); border-radius:22px; background:var(--auth-surface); color:var(--auth-text); box-shadow:0 24px 70px rgba(0,0,0,.28),inset 0 1px 0 rgba(255,255,255,.04); backdrop-filter:blur(14px); }
.auth-page-skin .auth-panel h2 { color:var(--auth-text); font-size:clamp(22px,3vw,29px); font-weight:800; }
.auth-page-skin .subtitle { color:var(--auth-muted); line-height:1.8; }
.auth-page-skin .form-group { margin-bottom:18px; }
.auth-page-skin .form-label { color:var(--auth-muted); font-size:13px; font-weight:600; }
.auth-page-skin .form-input, .auth-page-skin .otp-input { width:100%; min-height:46px; padding:11px 14px; border:1px solid rgba(145,205,194,.25); border-radius:10px; outline:none; background:var(--auth-input); color:var(--auth-text); font:inherit; transition:border-color .2s,box-shadow .2s,background .2s; }
.auth-page-skin .form-input::placeholder { color:#76918f; }
.auth-page-skin .form-input:focus, .auth-page-skin .otp-input:focus { border-color:var(--auth-accent); box-shadow:0 0 0 3px rgba(240,120,50,.16); background:rgba(5,24,31,.88); }
.auth-page-skin .form-input.input-error { border-color:#e07070; }
.auth-page-skin .btn-primary, .auth-page-skin .verify-btn, .auth-page-skin .login-btn, .auth-page-skin .reset-btn, .auth-page-skin .password-btn, .auth-page-skin .submit-btn { min-height:46px; border:0; border-radius:10px; background:var(--auth-accent); color:#fff; font:inherit; font-weight:700; cursor:pointer; box-shadow:0 8px 24px rgba(240,120,50,.2); transition:transform .18s,background .18s,opacity .18s,box-shadow .18s; }
.auth-page-skin .btn-primary:hover:not(:disabled), .auth-page-skin .verify-btn:hover:not(:disabled), .auth-page-skin .login-btn:hover:not(:disabled), .auth-page-skin .reset-btn:hover:not(:disabled), .auth-page-skin .password-btn:hover:not(:disabled), .auth-page-skin .submit-btn:hover:not(:disabled) { transform:translateY(-2px); background:var(--auth-accent-soft); box-shadow:0 12px 32px rgba(240,120,50,.3); }
.auth-page-skin button:disabled { opacity:.65; cursor:wait; }
.auth-page-skin .text-danger, .auth-page-skin .error-message { color:#f28a8a; }
.auth-page-skin .text-success, .auth-page-skin .success-message { color:#7ed6a2; }
.auth-page-skin .error-message, .auth-page-skin .success-message { background:rgba(5,24,31,.48); border-color:var(--auth-border); }
.auth-page-skin .btn-secondary { background:#31545b; color:#fff; border:0; }
.auth-page-skin .btn-link, .auth-page-skin a { color:var(--auth-accent-soft); }
.auth-page-skin .role-selection-content, .auth-page-skin .company-selection-content { background:#0d2b35; color:var(--auth-text); border:1px solid var(--auth-border); }
.auth-page-skin .company-option { border-color:var(--auth-border); background:rgba(5,24,31,.38); }
@media (max-width:767px) { .auth-page-skin { min-height:calc(100svh - 56px); padding:34px 14px 40px; } .auth-page-skin::before { background-size:min(560px,125vw) auto; opacity:.28; } .auth-page-skin .auth-panel { width:min(100%,440px); padding:28px 22px; } }


/* Match Register composition: visual left, auth panel right; visual behind panel on mobile. */
.otp-container.auth-page-skin, .verify-container.auth-page-skin, .password-container.auth-page-skin, .reset-container.auth-page-skin {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(320px, .92fr);
  align-items: center;
  gap: clamp(24px, 4vw, 72px);
  width: 100%;
  min-height: calc(100svh - 64px);
  padding: 72px clamp(24px, 5vw, 88px) 32px;
}
.otp-container.auth-page-skin::before, .verify-container.auth-page-skin::before, .password-container.auth-page-skin::before, .reset-container.auth-page-skin::before {
  inset: 8% 42% 4% 2%;
  background-size: min(680px, 56vw) auto;
  background-position: center;
  opacity: .62;
}
.otp-container.auth-page-skin > .auth-panel, .verify-container.auth-page-skin > .auth-panel, .password-container.auth-page-skin > .auth-panel, .reset-container.auth-page-skin > .auth-panel {
  grid-column: 2;
  justify-self: end;
  width: min(100%, 500px);
}
.reset-container.auth-page-skin > .language-switcher { position: absolute; z-index: 3; top: 18px; inset-inline-start: 24px; }
@media (max-width: 767px) {
  .otp-container.auth-page-skin, .verify-container.auth-page-skin, .password-container.auth-page-skin, .reset-container.auth-page-skin {
    position: relative;
    display: block;
    min-height: calc(100svh - 56px);
    padding: 34px 14px 40px;
  }
  .otp-container.auth-page-skin::before, .verify-container.auth-page-skin::before, .password-container.auth-page-skin::before, .reset-container.auth-page-skin::before {
    inset: -8% -18%;
    background-size: min(560px, 125vw) auto;
    opacity: .34;
  }
  .otp-container.auth-page-skin > .auth-panel, .verify-container.auth-page-skin > .auth-panel, .password-container.auth-page-skin > .auth-panel, .reset-container.auth-page-skin > .auth-panel {
    position: relative;
    z-index: 2;
    width: min(100%, 440px);
    margin: 0 auto;
  }
}

/* RegisterCompanyPhone has an extra inner container around its panel. */
.auth-page-skin > .login-container {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(320px, .92fr);
  align-items: center;
  gap: clamp(24px, 4vw, 72px);
  min-height: calc(100svh - 64px);
  padding: 0;
  background: transparent;
}
.auth-page-skin > .login-container > .login-card {
  grid-column: 2;
  justify-self: end;
  width: min(100%, 500px);
  position: relative;
  z-index: 2;
  background: var(--auth-surface);
  border: 1px solid var(--auth-border);
  border-radius: 22px;
  color: var(--auth-text);
  box-shadow: 0 24px 70px rgba(0,0,0,.28);
  backdrop-filter: blur(14px);
}
@media (max-width: 767px) {
  .auth-page-skin > .login-container { display: block; min-height: calc(100svh - 56px); }
  .auth-page-skin > .login-container > .login-card { width: min(100%, 440px); margin: 0 auto; }
}


/* Keep auth panels translucent like Register so the visual fades through them. */
.auth-page-skin .auth-panel,
.auth-page-skin .login-card,
.register-page .form-card {
  background: transparent !important;
  backdrop-filter: blur(4px);
}

/* Center the visual directly behind the panel on phone widths. */
@media (max-width: 767px) {
  .auth-page-skin::before {
    inset: 0;
    background-position: center center;
    background-size: min(112vw, 440px) auto;
    opacity: .5;
  }

  .auth-page-skin .auth-panel,
  .auth-page-skin .login-card,
  .register-page .form-card {
    position: relative;
    z-index: 4;
    background: transparent !important;
    margin-top: 150px !important;
    box-shadow: 0 18px 44px rgba(0, 0, 0, .18);
  }
}

/* Login fields must stay dark, including browser autofill. */
.register-page .form-card .form-input,
.login-page .form-card .form-input,
.login-page input.form-input {
  background: #05181f !important;
  background-color: #05181f !important;
  color: #f1f7f5 !important;
}

.register-page .form-card .form-input:-webkit-autofill,
.login-page .form-card .form-input:-webkit-autofill,
.login-page input.form-input:-webkit-autofill,
.login-page .form-input:-webkit-autofill:hover,
.login-page .form-input:-webkit-autofill:focus {
  -webkit-text-fill-color: #f1f7f5 !important;
  -webkit-box-shadow: 0 0 0 1000px #05181f inset !important;
  box-shadow: 0 0 0 1000px #05181f inset !important;
  background-color: #05181f !important;
  caret-color: #f1f7f5;
}


/* Use the same real visual column and sizing as Register/Login. */
.auth-page-skin.auth-visual-layout {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(320px, .92fr);
  align-items: center;
  gap: clamp(24px, 4vw, 72px);
  width: 100%;
  min-height: 100dvh !important;
  height: auto !important;
  padding: 72px clamp(24px, 5vw, 88px) 32px;
  box-sizing: border-box;
}
.auth-visual-layout::before,
.auth-visual-layout::after { display: none; }
.auth-visual-layout > .auth-panel { grid-column: 2; grid-row: 1; justify-self: end; }
.auth-visual-layout > .register-image-col { grid-column: 1; grid-row: 1; display: flex; align-items: center; justify-content: center; width: 100%; height: min(72svh, 680px); min-width: 0; overflow: hidden; padding: 0; }
.auth-visual-layout .visual { position: relative; display: block; width: min(100%, 680px); height: 680px; aspect-ratio: 1; overflow: visible; }
.auth-visual-layout .hero-orbit { position: absolute; inset: 0; z-index: 1; overflow: visible; pointer-events: none; }
.auth-visual-layout .visual-image { position: relative; display: block; width: 100%; height: 100%; object-fit: contain; }
@media (max-width: 767px) {
  .auth-page-skin.auth-visual-layout { display: block; min-height: 100dvh !important; padding: 34px 14px 40px; }
  .auth-visual-layout > .auth-panel { position: relative; z-index: 4; width: min(100%, 440px); margin: 0 auto; }
  .auth-visual-layout > .register-image-col { position: absolute; z-index: 0; inset: 0; display: block; width: 100%; height: 100%; pointer-events: none; }
  .auth-visual-layout .visual { position: absolute; top: 50%; left: 50%; width: min(112vw, 440px); height: 440px; transform: translate(-50%, -50%); max-width: none; }
}
</style>
